import { GRAPH_COLORED_NODE_CLASS_NAME, GRAPH_DEFAULT_NODE_CLASS_NAME } from "Common/componentUtils/constants";
import getShorterText from "Common/componentUtils/getShorterText";
import { ZOOM_LEVEL } from "Common/dictionaries/zoomLevel";
import { themeVariables } from "Components/theme";
import chroma from "chroma-js";
import map from "lodash/map";
import split from "lodash/split";
import { TemplateNodeStyle } from "yfiles";
import { NODE_GROUP_MIN_SIZE } from "../../constants";
import nodeType from "../nodeType";
import { fontSizeMap } from "./svgRenders";
export default () => {
    TemplateNodeStyle.CONVERTERS.colorToClassConverter = (color) => color
        ? `${GRAPH_DEFAULT_NODE_CLASS_NAME} ${GRAPH_COLORED_NODE_CLASS_NAME}`
        : GRAPH_DEFAULT_NODE_CLASS_NAME;
    TemplateNodeStyle.CONVERTERS.colorConverter = (styleTag, params) => {
        const parts = split(params, ",");
        if (parts.length !== 3)
            return "#fff";
        if (!(styleTag === null || styleTag === void 0 ? void 0 : styleTag.Color)) {
            const correctedColor = parts[0] === "fill"
                ? (styleTag === null || styleTag === void 0 ? void 0 : styleTag.Selected)
                    ? ""
                    : ""
                : themeVariables[(styleTag === null || styleTag === void 0 ? void 0 : styleTag.Selected) ? "brand-primary-500" : "gray-300"];
            return correctedColor || "#fff";
        }
        const luminanceFactor = parseFloat(parts[(styleTag === null || styleTag === void 0 ? void 0 : styleTag.Selected) ? 2 : 1]);
        if (!luminanceFactor)
            return "#fff";
        if (luminanceFactor === 1)
            return styleTag.Color;
        const prevLuminance = chroma(styleTag.Color).luminance();
        const newLuminance = Math.max(Math.min(prevLuminance + (1 - prevLuminance) * luminanceFactor, 1), 0);
        return chroma(styleTag.Color).luminance(newLuminance).css();
    };
    TemplateNodeStyle.CONVERTERS.needOpacityConverter = (color, opacityToApply) => (color ? opacityToApply : 0);
    TemplateNodeStyle.CONVERTERS.defaultStrokeWidthConverter = (color) => color ? 3 : 1;
    TemplateNodeStyle.CONVERTERS.groupStrokeWidthConverter = (itemSelected, itemSelectedWidth) => (itemSelected ? itemSelectedWidth : 1);
    TemplateNodeStyle.CONVERTERS.sizeConverter = (size, minSize) => size ? Math.max(size, minSize) : minSize;
    TemplateNodeStyle.CONVERTERS.sizeInnerConverter = (size, params) => {
        const sizes = map(split(params, ", "), e => Number.parseInt(e));
        return Math.max(size || 0, sizes[1]) - sizes[0];
    };
    TemplateNodeStyle.CONVERTERS.imageSizeConverter = (image, size) => (image ? size : 0);
    TemplateNodeStyle.CONVERTERS.sourceTaskNameConverter = (groupTag, zoomLevel) => {
        const sourceTaskName = (groupTag === null || groupTag === void 0 ? void 0 : groupTag.GroupName) || "";
        const width = Math.max(NODE_GROUP_MIN_SIZE.width, (groupTag === null || groupTag === void 0 ? void 0 : groupTag.NodeWidth) || 0);
        const fontSize = fontSizeMap[nodeType.GROUP][zoomLevel];
        const textMaxLength = zoomLevel === ZOOM_LEVEL.HIGH
            ? Math.round(width / (fontSize * 0.75))
            : Math.round(width / (fontSize * 0.6));
        return getShorterText(sourceTaskName, textMaxLength, true);
    };
    const getGroupNodesCountText = (groupTag) => (groupTag === null || groupTag === void 0 ? void 0 : groupTag.GroupObjectCount) ? `  ${groupTag.GroupObjectCount}  ` : "";
    TemplateNodeStyle.CONVERTERS.groupNodesCountConverter = (groupTag) => getGroupNodesCountText(groupTag);
    TemplateNodeStyle.CONVERTERS.groupNodesCountTransformConverter = (groupTag, zoomLevel) => {
        const fontSize = fontSizeMap[nodeType.GROUP][zoomLevel];
        const width = (getGroupNodesCountText(groupTag).length - 2) * fontSize * 0.65;
        return zoomLevel === ZOOM_LEVEL.HIGH ? `translate(-${width} 0)` : `translate(-${width / 2} 0)`;
    };
    TemplateNodeStyle.CONVERTERS.groupNodesCountXConverter = (groupWidth, zoomLevel) => (zoomLevel === ZOOM_LEVEL.HIGH ? groupWidth - 30 : groupWidth / 2);
    TemplateNodeStyle.CONVERTERS.groupNodesCountYConverter = (groupHeight, zoomLevel) => zoomLevel === ZOOM_LEVEL.HIGH
        ? fontSizeMap[nodeType.GROUP][zoomLevel] * 1.4
        : groupHeight / 1.8;
};
